import { Link } from 'react-router-dom'
import Hero from '../components/Hero'
import Card from '../components/Card'
import SectorCard from '../components/SectorCard'
import WhoWeAre from '../components/WhoWeAre'
import './HomeAbout.css'
import InnovationParallax from '../components/InnovationParallax'

const Home = () => {

  return (
    <>
      {/* Hero Section */}
      <Hero 
        title="Your Trusted Commercial Cleaning Partner"
        subtitle="At Adept Services, we provide top-notch commercial cleaning solutions tailored to meet your business needs."
        isSliding={true}
        showCTA={true}
        ctaText="Contact Us"
        ctaLink="/contact"
        height="78.2vh"
      />

      {/* Who We Are (Animated About) */}
      <WhoWeAre />

      {/* Services */}
      <section id="services">
        <div className="section-header">
          <h2>Our Services</h2>
        </div>
        <div className="services-grid">
          <Card
            title="Commercial Cleaning"
            description="We provide routine and periodic cleaning for offices, retail stores and multi‑level buildings, using modern methods and equipment to maintain a hygienic, welcoming environment for staff and visitors."
            imageUrl="/services/commercial_cleaning.png"
            linkTo="/services/commercial-cleaning"
          />
          <Card
            title="Specialised Cleaning"
            description="Our teams tackle jobs beyond standard cleaning—such as high‑rise windows, industrial flooring and sterile environments following strict safety and regulatory protocols to deliver reliable, compliant results."
            imageUrl="/services/specialized_cleaning.png"
            linkTo="/services/specialized-cleaning"
          />
          <Card
            title="Hygiene Services"
            description="We focus on infection control by disinfecting high‑touch surfaces and communal areas. These programmes help reduce germ transmission and support healthier workplaces and care facilities."
            imageUrl="/services/hygiene_services.png"
            linkTo="/services/hygiene-services"
          />
          <Card
            title="Consumable Services"
            description="We manage the supply and timely replenishment of consumables like paper products, soap and sanitiser. This service integrates with your cleaning schedule to keep facilities stocked without interruption."
            imageUrl="/services/consumable_services.png"
            linkTo="/services/consumable-services"
          />
        </div>
      </section>

      {/* Sectors We Serve */}
      <section id="sectors">
        <div className="section-header">
          <h2>Sectors We Serve</h2>
        </div>
        <div className="sectors-grid">
          <SectorCard
            title="Commercial & Industrial"
            icon="/sectors/commercial.png"
            linkTo="/sectors/commercial-industrial"
          />
          <SectorCard
            title="Hospitality & Leisure"
            icon="/sectors/hospitality.png"
            linkTo="/sectors/hospitality"
          />
          <SectorCard
            title="Education Campuses"
            icon="/sectors/education.png"
            linkTo="/sectors/education-and-institutions"
          />
          <SectorCard
            title="Healthcare Facilities"
            icon="/sectors/health.png"
            linkTo="/sectors/aged-care-healthcare"
          />
          <SectorCard
            title="Data Centers & Technology Spaces"
            icon="/sectors/data.png"
            linkTo="/sectors/technology-data-centres"
          />
          <SectorCard
            title="Government & Infrastructure"
            icon="/sectors/government.png"
            linkTo="/sectors/government-public"
          />
        </div>
      </section>

      {/* Cleaning Meets Innovation */}
      <section id="innovation">
        <div className="section-header">
          <h2>Cleaning Meets Innovation</h2>
        </div>
        <InnovationParallax />
      </section>

      {/* ESG Snippet */}
      <section id="esg">
        <div className="esg-layout">
          <div className="esg-text-section">
            <div className="section-header">
              <h2>Environmental, Social & Governance (ESG)</h2>
            </div>
            <div className="esg-text">
              <p>We are dedicated to operating responsibly by managing our environmental impact, upholding strong social values, and ensuring transparent governance. Our approach focuses on reducing emissions and waste, fostering diversity and fairness across our workforce and supply chains, and maintaining the highest standards of accountability, ethics, and compliance to deliver long-term value for all stakeholders.</p>
              <Link className="cta-button" to="/esg">Learn More</Link>
            </div>
          </div>
          <div className="esg-image">
            <img src="/esg/esg1.svg" alt="ESG - Environmental, Social & Governance" />
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="cta-section">
        <h2>Connect With Us Today</h2>
        <p>Our team is always here for you. From learning more about our services to discussing partnership opportunities or getting support, we’re ready to assist whenever you need us.</p>
        <Link className="cta-button" to="/contact">Enquire Now</Link>
      </section>
    </>
  )
}

export default Home
